import { cva } from 'class-variance-authority'

/** `contained` lines the header up with the 1024px body column on Overview, Analytics and Settings. */
export const headerContentVariants = cva('mx-auto w-full', {
  variants: {
    contentWidth: {
      full: '',
      contained: 'max-w-5xl',
      wide: 'max-w-screen-2xl',
    },
  },
  defaultVariants: {
    contentWidth: 'full',
  },
})
